import React, {Fragment} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Button} from '@edume/magnificent';

import styles from './styles.module.scss';

const AssessmentPreviewButton = ({isButtonLight, buttonText}) => (
  <Fragment>
    <Button
      onClick={() => {}}
      noMarginTop
      noMarginLeft
      disabled={false}
      isLightTheme={isButtonLight}
      type='progress'
      dataAutomation='preview-nav-button'
    >
      {buttonText}
    </Button>
  </Fragment>
);

AssessmentPreviewButton.propTypes = {
  isButtonLight: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default CSSModules(AssessmentPreviewButton, styles);
